<template>
  <div>
    <HeaderIndex></HeaderIndex>
    <div class="w1100">
      <div class="marginT10">
        <div class="is-postion fb">
          <div class="is-posbg">
            您当前的位置：<a href="/">网站首页</a>
          </div>
        </div>
        <div style="border:1px solid #ccc; border-top:none; padding-top:15px;">
          <div class="border_l border_r border_b border_ECEAEB">
            <div id="BodyLabel" style="padding:20px 40px 40px 40px;line-height:28px; font-size:14px;overflow:hidden;">
              <p style="text-align: center;font-weight: bold;">监督举报方式公告</p>
              <p style="text-indent: 2em;">严明换届纪律就是严明政治纪律和政治规矩。为保证全市换届工作顺利进行，潜山市纪委、潜山市委组织部、潜山市监委将严格贯彻落实“十严禁”换届纪律，严肃查处违反换届纪律的问题。请您对发现或听到的拉票贿选、买官卖官、跑官要官、违规干预、说情打招呼等问题，及时向组织报告或反映，也可以通过信访举报渠道向纪检监察机关、组织部门反映。</p>
              <p style="text-indent: 2em;">潜山市纪委、潜山市监委信访举报电话：12388</p>
              <p style="text-indent: 2em;">潜山市委组织部举报电话：12380-3   举报邮箱：qssgbjdk@163.com</p>
            </div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <FooterIndex name="footerIndex"></FooterIndex>
  </div>
</template>

<script>
import FooterIndex from './FooterIndex'
import HeaderIndex from './HeaderIndex'
import '../assets/css/css.css'

export default {
  name: 'ReportQuestion',
  components: {
    FooterIndex,
    HeaderIndex
  }
}
</script>

<style scoped>
.titleInfo { width:100%; clear:both; height:30px; line-height:30px; text-align:center; font-size:12px; border-bottom:1px dashed #cccccc; color:#666666; }
</style>



// WEBPACK FOOTER //
// src/components/reportQuestion.vue